module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-up-photo"
  }, [_c('header', [_c('div', {
    staticClass: "grid-container header"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/images/global/logo.svg")
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn bg-one active",
    attrs: {
      "to": "login"
    }
  }, [_vm._v("Log In")])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "shift-4 col-4"
  }, [_c('profile-image')], 1)])])]), _vm._v(" "), _c('section', {
    staticClass: "sign-up-navigation"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('a', {
    staticClass: "link-back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.stepBack($event)
      }
    }
  }, [_vm._v("Change Information")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-big bg-four active",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.progress($event)
      }
    }
  }, [_vm._v("Next")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "instructions"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('h2', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Add a picture to your profile.")]), _vm._v(" The most popular profiles usually have images.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24036839"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/register/Register-Step-4.vue
// module id = 688
// module chunks = 1